<nwm-menu />
<div class="content">
  @if (!user?.isAccountant) {
    <div class="main">
      <div class="row no-gutters mb-5 mt-4">
        <div class="col-xxl-10 offset-xxl-1" style="min-height:362px">
          <h1 class="mt-4 mb-2">Advisory Team</h1>
          <p>We are here to help. Please feel free to contact any of us.</p>
          <button class="btn-primary sml-btn" (click)="openModalToContactAdvisoryTeam(content)">Contact Advisory Team</button>
          @if (advisors && advisors.length) {
            <div class="row mt-4">
              @for (advisor of advisors; track advisor) {
                <div class="col-xl-3 col-sm-6 advisor-card">
                  <div class="advisor">
                    <div class="img-container">
                      <a href="{{advisor.WebsiteUrl}}" target="_blank" [class.disable]="!advisor.WebsiteUrl" aria-label="Advisor Info">
                        <img src="{{advisor.ImageUrl}}" class="img" (error)="loadDefaultImage($event)" alt="Advisor {{advisor.SupportName}} Image">
                      </a>
                    </div>
                    <hr>
                      <div class="content-container">
                        <div class="h3-text">{{advisor.SupportName}}</div>
                        <span class="creds" [innerHTML]="(advisor.Designations==='')? '&nbsp;': advisor.Designations"></span>
                        <p class="title" [innerHTML]="advisor.Title"></p>
                        @if (advisor.Email) {
                          <a class="email" href="mailto:{{advisor.Email}}"><span class="material-icons mr-2">email</span>{{advisor.Email}}</a>
                          }<br>
                          @if (advisor.DirectPhoneNumber) {
                            <a href="tel:{{advisor.DirectPhoneNumber}}" class="phone"><span class="material-icons mr-2">call</span>{{advisor.DirectPhoneNumber}}</a>
                          }
                        </div>
                      </div>
                    </div>
                  }
                  @if (dummyCards && dummyCards.length) {
                    @for (card of dummyCards; track card; let i = $index) {
                      <div class="col-xl-3 col-sm-6 advisor-card d-xl-block d-none" [ngClass]="{'d-sm-block': i===0 && advisors.length % 2 }">
                        <div class="advisor-card-empty">
                        </div>
                      </div>
                    }
                  }
                </div>
              }
            </div>
          </div>
          <ng-template #content let-modal>
            <nwm-advisor-contact formAction="MessageAdvisor" (formCancelled)="modal.close()" />
          </ng-template>
        </div>
      }
    </div>
